import { render, staticRenderFns } from "./OutgoingInvoice2.vue?vue&type=template&id=32c5f3b8&"
import script from "./OutgoingInvoice2.vue?vue&type=script&lang=js&"
export * from "./OutgoingInvoice2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports